import React from 'react';
import { useGame } from '../context/GameContext';

export default function Boon() {
  const { pendingBoon, chooseBoon } = useGame();
  if (!pendingBoon) return null;
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-6" data-testid="boon-screen">
      <div className="text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">✦ THE ORACLE OF SLOP ✦</div>
      <h1 className="font-display text-5xl font-black uppercase text-[color:var(--neon)] mt-2 max-w-3xl text-center">CHOOSE YOUR BLESSING</h1>
      <div className="mt-4 max-w-2xl text-center text-[color:var(--text-dim)] text-sm">One boon before you descend. Choose wisely, gooner.</div>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl">
        {pendingBoon.boons.map((b, i) => (
          <button
            key={b.id}
            className="brutal-btn brutal-btn-pink text-left flex flex-col items-start gap-2 p-6"
            onClick={() => chooseBoon(i)}
            data-testid={`boon-choice-${i}`}
          >
            <div className="text-5xl">{b.art}</div>
            <div className="font-display font-black text-2xl text-[color:var(--pink)]">{b.name}</div>
            <div className="text-sm text-[color:var(--text)] normal-case tracking-normal">{b.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
